// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// CSS,SCSS,SASS
import '@/assets/dashmix/scss/main.scss'
import '@/assets/css/base.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// Build in component
import PageHeader from '@/components/PageHeader'
import PageLoading from '@/components/PageLoading'
import PageToolbar from '@/components/PageToolbar'
import LoadingButton from '@/components/LoadingButton'
import ModalShowData from '@/components/modals/ShowData'
import ErrorMessage from '@/components/ErrorMessage'
// Build in module
import TextHelper from '@/helpers/TextHelper'
// Vue 3rd party module
import ToggleButton from 'vue-js-toggle-button'
import VeeValidate from 'vee-validate'
import vmodal from 'vue-js-modal'
import VueFormWizard from 'vue-form-wizard'
import vSelect from 'vue-select'

// Bootstrap module
import BootstrapVue from 'bootstrap-vue'

// ========== [REGISTER] ==========
Vue.config.productionTip = false

// Register build in component
Vue.component('page-header', PageHeader)
Vue.component('page-loading', PageLoading)
Vue.component('page-toolbar', PageToolbar)
Vue.component('loading-button', LoadingButton)
Vue.component('modal-show-data', ModalShowData)
Vue.component('error-message', ErrorMessage)
Vue.component('v-select', vSelect)

// Register 3rd Party module
Vue.use(ToggleButton)
Vue.use(TextHelper)
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })
Vue.use(VueFormWizard)

// Register Vue 3rd party module
Vue.use(vmodal)

// Register NPM module
Vue.use(BootstrapVue)
// ========== [REGISTER] ==========

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
